import React from "react";
import Letter from "./HR/Letter/Letter";

export default function LetterPage() {
  return (
    <div className="px-6 space-y-6 animate-in fade-in duration-300">
      <Letter />
    </div>
  );
}
